import { render, staticRenderFns } from "./levelinfolist.vue?vue&type=template&id=abe481f6&scoped=true"
import script from "./levelinfolist.vue?vue&type=script&lang=js"
export * from "./levelinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe481f6",
  null
  
)

export default component.exports